exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflow-input-model-select.loading .ant-select-selection-item {\n  display: none;\n}\n", ""]);

// exports
